import { NEXT_PUBLIC_IMAGE_URL } from "@/common";

export const careerPath = [
  {
    versionA: {
      title: 'Cứ đi một bước nhỏ trước.',
      titleColor: 'Upzi đi cùng bạn.',
      description:
        'Take the guesswork out of managing your money. Our AI-powered budgeting tool adapts to your lifestyle and helps you stay on track.',
      bullets: [
        {
          title: 'Hiểu mình trước đã',
          description:
            'Import CV, làm test nhanh để hiểu mình mạnh gì, thích gì.',
          image: `${NEXT_PUBLIC_IMAGE_URL}/image/landing-page/careerpath_1.jpg`,
        },
        {
          title: 'Tự chọn hướng đi',
          description:
            'Gợi ý job path xịn dựa trên data cá nhân, so sánh ưu – nhược từng lựa chọn.',
          image: `${NEXT_PUBLIC_IMAGE_URL}/image/landing-page/careerpath_2.jpg`,
        },
        {
          title: 'Lên kế hoạch dài hạn',
          description:
            'Từ job bạn chọn, Upzi vẽ lộ trình dài hạn: từ Junior → Mid → Senior → Manager, kèm skill cần học từng chặng.',
          image: `${NEXT_PUBLIC_IMAGE_URL}/image/landing-page/careerpath_3.jpg`,
        },
      ],
    },
    versionB: {
      title: 'Lộ trình nghề nghiệp được cá nhân hoá bằng AI',
      description:
        'Take the guesswork out of managing your money. Our AI-powered budgeting tool adapts to your lifestyle and helps you stay on track.',
      bullets: [
        {
          title: 'Hiểu mình trước đã',
          description:
            'Import CV, làm test nhanh để hiểu mình mạnh gì, thích gì.',
          image: `${NEXT_PUBLIC_IMAGE_URL}/image/landing-page/careerpath_1.jpg`,
        },
        {
          title: 'Tự chọn hướng đi',
          description:
            'Gợi ý job path xịn dựa trên data cá nhân, so sánh ưu – nhược từng lựa chọn.',
          image: `${NEXT_PUBLIC_IMAGE_URL}/image/landing-page/careerpath_2.jpg`,
        },
        {
          title: 'Lên kế hoạch dài hạn',
          description:
            'Từ job bạn chọn, Upzi vẽ lộ trình dài hạn: từ Junior → Mid → Senior → Manager, kèm skill cần học từng chặng.',
          image: `${NEXT_PUBLIC_IMAGE_URL}/image/landing-page/careerpath_3.jpg`,
        },
      ],
    },
  },
];
